import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    borderTop: {
      borderTop: '2px solid #1582dc',
    },
    monthToDateHeader: {
      fontSize: '1.4rem',
      marginTop: '1rem',
      paddingLeft: '1rem',
    },
    monthToDateEarnings: {
      fontSize: '2.4rem',
      color: '#2B8DDF',
      paddingLeft: '1rem',
      marginTop: '1rem',
    },
    chartBox: {
      width: '50%',
    },
    paper: {
      width: '100%',
      boxShadow:'none',
      border:'1px solid #e0e0e0'
    },
    chartTitle: {
      padding: '2rem',
      textAlign: 'left',
      fontWeight: 'bold',
      fontSize: '1.5rem'
    },
    barContainer: {
      width: '100%',
      marginTop: '10px',
      padding: '3rem'
    },
    headerRow: {
      borderBottom: '1px solid #e0e0e0'
    },
    headerWrapper: {
      border: '1px solid #e0e0e0',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      borderBottom: 'none',
      paddingRight: '2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#fff',
    }
  })
);

export default useStyles;
